// Vendors
import { ModalContainerComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
// Components
import { CancelDropModalCloseComponent } from './components/close/cancel-drop-modal-close.component';
import { CancelDropModalDescriptionComponent } from './components/description/cancel-drop-modal-description.component';
import { CancelDropModalFooterComponent } from './components/footer/cancel-drop-modal-footer.component';
import { CancelDropModalTitleComponent } from './components/title/cancel-drop-modal-title.component';
// Constants
import { CANCEL_DROP_MODAL_COMPONENT_PROPS } from './constants/cancel-drop-modal.constants';
// Hooks
import CancelDropModalHook from './hooks/cancel-drop-modal.hook';
// Types
import { CancelDropModalComponentType } from './types/cancel-drop-modal.component.type';

const CancelDropModalComponent = ({
  id,
  description,
  onClose,
  onLinkClose,
  onOpenModal,
  showModal,
  title,
  footerConfiguration,
}: CancelDropModalComponentType): React.JSX.Element | null => {
  const { maxWidth } = CancelDropModalHook({ id, onOpenModal, showModal });

  return showModal ? (
    <ModalContainerComponent
      {...CANCEL_DROP_MODAL_COMPONENT_PROPS}
      maxWidth={maxWidth}
      actions={<CancelDropModalCloseComponent {...{ onClose }} />}
      content={<CancelDropModalDescriptionComponent {...{ description }} />}
      footer={<CancelDropModalFooterComponent {...{ id, onLinkClose, footerConfiguration }} />}
      title={<CancelDropModalTitleComponent {...{ title }} />}
    />
  ) : null;
};
export { CancelDropModalComponent };
